exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#DragDropFileUploadComponent .dragDropBorder{border:2px dashed #999}#DragDropFileUploadComponent .isDragging{background-color:#999!important;border:2px solid red!important}", ""]);

// exports
